const config = {
  // basename: only at build time to set, and Don't add '/' at end off BASENAME for breadcrumbs, also Don't put only '/' use blank('') instead,
  // Note: while doing local dev, keep basename as 'react-admin-template' to make sure auth works
  name: 'Goods In Admin',
  basename: '/goodsin-admin',
  defaultPath: '/portal',
  domain: 'int-prod.ecom.prod.jjfoodservice.com',
  localDomain: 'admin-local.jjfoodservice.co.uk',
  fontFamily: `'Roboto', sans-serif`,
  borderRadius: 12,
  version: '3.1.1',
  gqlApi: '/api/gpi/graphql'
};

export default config;